import { css } from '@emotion/react'



export const GlobalStyles = css`
    :root {
    --primary-color: #FFE000;
    --cool-gray: 51, 51, 51;
    --main-bg: #fdfeff;
    --sidebar-bg: #f6f7f9;
    --border-color: #e6ecf1;
    }

    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    html{
        scroll-padding-top: 100px;
    }


    html, body {
        font-family: Roboto, "helvetica neue", helvetica, Arial, sans-serif;
        font-size: 16px;
        background: var(--main-bg);
        color: var(--cool-gray);
    }

    p {
        line-height: 1.5em;
        margin-bottom: 1.1em;
        font-weight: 300;
        letter-spacing: 0.2px;
    }

    body{
        padding-top: 80px;
        overflow-y:scroll;
    }

    a:focus-visible, button:focus-visible {
        outline: 2px solid #000;
        outline-offset: 2px;
    }

    a:hover{
        text-decoration: underline !important;
        color:#0645AD;
    }
    
    a {
        transition: color 0.15s;
        text-decoration: underline;
        font-weight: 500;
        color: var(--cool-gray);
    }   
    pre {
        border: 0 !important;
        background-color: rgb(245, 247, 249); /* !important; */
        margin-bottom: 2px;
    }
    img {
        max-width: 100%;
    }

    blockquote{
        padding: 10px 20px;
        margin: 0 0 20px;
        font-size: 17.5px;
        border-left: 5px solid #eee;
        p{
            margin-bottom: 0;
        }
    }

    table {
        padding: 0;
        margin-bottom: 1.5em;
        border-spacing: 0;
        border-collapse: collapse;
        tr {
            border-top: 1px solid #cccccc;
            background-color: white;
            margin: 0;
            padding: 0; 
            th {
                font-weight: bold;
                border: 1px solid #cccccc;
                text-align: left;
                margin: 0;
                padding: 6px 13px; 
            }
            td {
                border: 1px solid #cccccc;
                text-align: left;
                margin: 0;
                padding: 6px 13px; 
            }
            th :first-of-type,
            td :first-of-type{
                margin-top: 0;
            }

            th :last-child,
            td :last-child{
                margin-bottom: 0;
            }
        }
        tr:nth-of-type(2n) {
            background-color: #f8f8f8; 
        }
    }

`

const  mediaQueryMaxWidth = (width) => `@media (max-width: ${width}px)`;
// const mediaQueryMinWidth = (width) => `@media (min-width: ${width}px)`;

const viewportSmall = 400;
const viewportMedium = 1023;

export const small = mediaQueryMaxWidth(viewportSmall);
export const medium = mediaQueryMaxWidth(viewportMedium);